import { styled, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const TableHeader = styled(Box)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	padding: theme.spacing(1, 1.5),
	borderBottom: "none",
	fontWeight: 100,
	background: theme =>
		theme.palette.mode === "dark"
			? alpha(theme.palette.grey[900], 0.5)
			: alpha(theme.palette.grey[100], 0.4),
	fontSize: "0.65rem",
	color: "light",
	position: "sticky",
	top: 0,
	zIndex: 1,
	boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
	borderRadius: "0.75rem 0.75rem 0 0"
}));

export const SortableHeaderCell = styled(Box)(({ theme, sortable }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	position: "relative",
	cursor: sortable ? "pointer" : "default",
	userSelect: sortable ? "none" : "auto",
	"&:hover": {
		opacity: sortable ? 0.8 : 1
	}
}));

export const TableRow = styled(Box)(({ theme, selected }) => ({
	display: "flex",
	alignItems: "center",
	padding: theme.spacing(0.75, 1.5),
	borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`,
	cursor: "pointer",
	transition: "all 0.15s ease",
	backgroundColor: selected ? alpha(theme.palette.info.main, 0.08) : "transparent",
	"&:hover": {
		backgroundColor: selected ? alpha(theme.palette.info.main, 0.12) : theme.palette.action.hover
	}
}));
